import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from './api';

const UNREAD_POLL_INTERVAL_MS = 60_000;

export function useNotifications(unreadOnly = false) {
  return useQuery({
    queryKey: ['notifications', { unread: unreadOnly }],
    queryFn: () => api.listNotifications({ unread: unreadOnly }),
  });
}

export function useUnreadNotificationCount() {
  return useQuery({
    queryKey: ['notifications', 'unread-count'],
    queryFn: () => api.getUnreadNotificationCount(),
    refetchInterval: UNREAD_POLL_INTERVAL_MS,
    refetchIntervalInBackground: false,
  });
}

export function useMarkNotificationRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.markNotificationRead(id),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['notifications'] });
    },
  });
}

export function useMarkAllNotificationsRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.markAllNotificationsRead(),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['notifications'] });
    },
  });
}
